<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    :routeback="routeback"
  >
    <FormField
      label="E-mail"
      v-model="form.email"
      :validation="$v.form.email"
      :disabled="!editarEmailEnabled"
    />

    <FormAutocomplete
      placeholder="Selecionar categorias"
      :options="categorias"
      v-model="form.setoresId"
      multiple
      chips
      :clearable="true"
      :disabled="readonly || categoriasLoading"
      :loading="categoriasLoading"
    />

    <v-row>
      <v-col cols="12">
        <div class="font-weight-medium">Permissões</div>
        <v-row>
          <v-col
            v-for="permissao in form.permissoes"
            :key="permissao.id"
            cols="12"
            sm="6"
            md="4"
          >
            <FormSwitch
              v-model="permissao.selected"
              :label="permissao.descricao"
              @change="onPermissaoChange"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import FormButton from "@/components/form/FormButton";
import { required } from "vuelidate/lib/validators";
import locationsMixin from "@/mixins/locations";
import { mapGetters } from "vuex";
import { USUARIO_CREATE } from "@/store/actions/cliente";
import { SETOR_FOLHA_LOAD } from "@/store/actions/setor";
import {
  LOAD_USUARIO_PERMISSOES,
  USUARIO_CLIENTE_LOAD,
  USUARIO_CLIENTE_UPDATE
} from "../../../../store/actions/usuario";
import FormAutocomplete from "@/components/form/FormAutocomplete";

export default {
  name: "ClienteUsuarioForm",
  mixins: [locationsMixin],
  components: {
    SidePopup,
    FormField,
    FormButton,
    FormSwitch,
    FormAutocomplete
  },
  validations: {
    form: {
      email: { required }
    }
  },
  data: () => ({
    form: {
      email: "",
      permissoes: [],
      setoresId: []
    },
    idClient: "",
    idcadastroextracliente: "",
    idfornecedor: "",
    idusuario: "",
    categorias: [],
    categoriasLoading: false
  }),
  async created() {
    this.idusuario = this.$route.params.id;
    this.idClient = this.$route.params.idclient;
    this.idcadastroextracliente = this.$route.params.idcadastroextracliente;
    this.idfornecedor = this.$route.params.idfornecedor;
    let permissoesDefault = [];

    this.ensureCategorias();

    if (this.idusuario !== "novo") {
      this.$store
        .dispatch(USUARIO_CLIENTE_LOAD, {
          idusuario: this.idusuario,
          idcadastroextracliente: this.idcadastroextracliente
        })
        .then(async usuario => {
          this.form.email = usuario.usuario.email;
          if (usuario.permissoes && usuario.permissoes.length) {
            usuario.permissoes.forEach(p => {
              permissoesDefault.push(p.idPermissao);
            });
          }

          if (
            usuario.restricoes &&
            usuario.restricoes.setoresId &&
            usuario.restricoes.setoresId.length
          ) {
            this.form.setoresId = usuario.restricoes.setoresId || [];
          }

          this.$store.dispatch(LOAD_USUARIO_PERMISSOES).then(permissoes => {
            this.form.permissoes = permissoes.map(p => ({
              ...p,
              selected: permissoesDefault.includes(p.id)
            }));
          });
        });
    } else {
      permissoesDefault = ["submissao_pedido"];
      this.$store.dispatch(LOAD_USUARIO_PERMISSOES).then(permissoes => {
        this.form.permissoes = permissoes.map(p => ({
          ...p,
          selected: permissoesDefault.includes(p.id)
        }));
      });
    }
  },
  computed: {
    ...mapGetters(["getFornecedorTag"]),
    title() {
      if (this.idusuario !== "novo") {
        return "Editar usuário";
      }
      return "Novo usuário";
    },
    routeback() {
      return `/fornecedor/cadastro/cliente/${this.idClient}/lista/usuario`;
    },
    editarEmailEnabled() {
      return this.idusuario === "novo";
    }
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      const idcadastroextracliente = this.idcadastroextracliente;
      const idfornecedor = this.idfornecedor;

      let payload = {
        ...this.form,
        permissoes: this.form.permissoes.filter(p => p.selected).map(p => p.id),
        categoriasrestricao: this.form.setoresId || [],
        idcadastroextracliente,
        idfornecedor,
        idusuario: this.idusuario === "novo" ? undefined : this.idusuario
      };

      const action =
        this.idusuario === "novo" ? USUARIO_CREATE : USUARIO_CLIENTE_UPDATE;

      const msg =
        this.idusuario === "novo"
          ? "Usuário cadastrado com sucesso"
          : "Usuário atualizado com sucesso";

      this.handleSubmit(action, payload, msg);
    },
    handleSubmit(action, payload, msg) {
      this.$store.dispatch(action, payload).then(() => {
        this.$vueOnToast.pop("success", msg);
        this.$router.replace({
          path: this.routeback,
          query: this.$route.query
        });
        this.$emit("close");
      });
    },
    onClose() {
      this.$emit("close");
    },
    async ensureCategorias() {
      if (this.categorias.length || this.categoriasLoading) {
        return;
      }

      this.categoriasLoading = true;

      try {
        const data = await this.$store.dispatch(SETOR_FOLHA_LOAD);
        this.categorias = (data || []).map(c => ({
          ...c,
          text: c.rotulo,
          value: c.id
        }));
      } catch (error) {
        this.$vueOnToast.pop("error", "Falha ao buscar categorias");
      } finally {
        this.categoriasLoading = false;
      }
    }
  }
};
</script>
